import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import SearchSection from './SearchSection';

const rootNode = document.getElementById('app-insights-search-root');

class AppInsightsPage extends Component {

  render() {
    return(
      <div>
        <SearchSection />
      </div>
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<AppInsightsPage />);
});
